export const defaultValuesForm = {
  videoUrls: [{ value: '' }],
  notes: '',
};
